import React, { Component } from 'react';
import withRouter from '../../lib/withRouter';
import Authentication from './../../session';
import { RadioButton } from 'primereact/radiobutton';
import { CancelRed, GreenCheck } from '../../svgIcons';
import LoadingComponent from '../../loadingComponent';
import Service from '../../services';
import { baseUrlAdmin } from '../../../store/apiConstants';
import { Toast } from 'primereact/toast';
import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import { Button } from 'primereact/button';
import { BasicLazyParams } from '../../../utile';
import { debounce } from 'lodash';
import ClassetInputText from '../../../classetComponents/classetInputText';
import { Dialog } from 'primereact/dialog';
import '../styles.scss';
import ClassetTextArea from '../../../classetComponents/classetTextArea';
import BranchToSectionApprovalHierarchy from '../../BaseDropdownComponents/BranchToSectionApprovalHierarchy';
import { FilterMatchMode, FilterOperator } from 'primereact/api';
import { InputText } from 'primereact/inputtext';

// const searchTypeOptions = [
//     { label: 'Student Name', value: 'studentName' },
//     { label: 'Enrollment Number', value: 'enrollmentNumber' }
// ];

const feeConcessionTypesOptions = [
    { value: 'merit', label: 'Merit-based' },
    { value: 'sports', label: 'Sports' },
    { value: 'financial', label: 'Financial Aid' },
    { value: 'alumni', label: 'Alumni' },
    { value: 'staff', label: 'Staff Child' }
];

class FeeConcessionApprovals extends Component {
    constructor(props) {
        super(props);
        this.studentSearchRef = React.createRef(); // <-- Add this line

        this.state = {
            lazyParams: BasicLazyParams,
            searchType: 1,
            searchInput: '',
            studentInfo: [],
            raisedFeeConcessionsData: {},
            studentId: null,
            selectedRows: [],
            searchLevel: 1,
            feeConcessionTypesOptions: feeConcessionTypesOptions,
            // searchType: searchTypeOptions[0].value,
            viewConcessionsDetails: false,
            remarks: '',
            showBulkApprovalDialog: false,
            bulkApprovalRemarks: '',
            filters: {

                'global': { value: null, matchMode: FilterMatchMode.CONTAINS },
                'name': { operator: FilterOperator.AND, constraints: [{ value: null, matchMode: FilterMatchMode.STARTS_WITH }] },

            },
            globalFilterValue: '',
        };
        this.debouncedApiCall = debounce(this.getStudentsInfo, 500);
        this.service = new Service();
    }

    setDropdownValues = (dropdownsData, payload) => {
        this.setState(
            {
                dropdownsData,
            },
            () => {
                // Check if branchIds is empty array and prevent API call
                if (!this.state?.dropdownsData?.branchIds ||
                    (Array.isArray(this.state?.dropdownsData?.branchIds) && this.state?.dropdownsData?.branchIds.length === 0)) {
                    console.log('No branches selected, skipping API call');
                    this.setState({
                        isLoading: false,
                        studentInfo: [],
                        studentstotalRecords: 0
                    });
                    return;
                }

                // Only call API if branchIds is not empty
                this.getStudentsInfo();
            }
        );
    };

    //     setDropdownValues = (dropdownsData, payload) => {
    //     // Ensure hierarchy data is properly structured
    //     const safeHierarchy = dropdownsData?.heirarchy || {
    //         adminLevels: [],
    //         branchId: '',
    //         boardId: '',
    //         classId: '',
    //         sectionId: ''
    //     };

    //     this.setState(
    //         {
    //             dropdownsData: {
    //                 ...dropdownsData,
    //                 heirarchy: safeHierarchy // Ensure hierarchy is always defined
    //             },
    //             studentIds: payload?.studentIds || [],
    //             enrollmentIds: payload?.enrollmentIds || [],
    //         },
    //         () => {
    //             this.getStudentsInfo();
    //         }
    //     );
    // };

    getStudents = () => {
        let academicYear = localStorage.getItem('userAcademicYear');
        // let { lazyParams } = this.state;
        this.setState({ isLoading: true });
        let url = `${baseUrlAdmin}/fine/student`;
        let payload = {
            branchId: this.state.dropdownsData?.branchId,
            boardId: this.state.dropdownsData?.boardId,
            classId: this.state.dropdownsData?.classId,
            sectionId: this.state.dropdownsData?.sectionId,
            academicYear: academicYear
        };
        if (payload?.sectionId) {
            this.service
                .post(url, payload, true)
                .then((data) => {
                    const studentsData = data?.res?.data.map((each) => {
                        return {
                            label: each?.name,
                            value: each?.user_id
                        };
                    });

                    if (data?.status) {
                        this.setState({
                            students: studentsData,
                            isLoading: false
                        });
                    } else {
                        this.setState({ isLoading: false });
                        this.toast.show({ severity: 'error', summary: 'Some error occured', detail: data.errMessage, life: 3000 });
                    }
                })
                .catch((error) => {
                    this.setState({ isLoading: false });
                });
        } else {
            this.setState({ isLoading: false });
        }
    };
    onHandleViewFeeConcessions = (data) => {
        this.setState({
            viewConcessionsDetails: true,
            raisedFeeConcessionsData: data
        });
    };
    onHandleConcessionClose = () => {
        this.setState(
            {
                viewConcessionsDetails: false,
                raisedFeeConcessionsData: {},
                remarks: ''
            },
            () => this.getStudentsInfo()
        );
    };
    onShowDetailedReport = () => {
        this.setState({
            isLoading: true
        });
    };
    onHandleApprovedConcessions = (selectedStudent) => {
        this.setState({ isLoading: true });
        const { raisedFeeConcessionsData, remarks } = this.state;
        // handle every object has approved status
        let isAllConcessionsChecked = true;
        const concessionMode = (raisedFeeConcessionsData?.concessionMode || 'ADD').toUpperCase();
        const pendingConcessions = raisedFeeConcessionsData?.concessionsRaised?.filter(e => e?.isClosed == false || e?.isClosed == undefined) || [];

        if (raisedFeeConcessionsData?.concessionsRaised?.length) {
            for (const el of pendingConcessions) {
                if (!el.hasOwnProperty('isConcessionApproved')) {
                    isAllConcessionsChecked = false;
                    break;
                }
            }
        }
        if (!isAllConcessionsChecked) {
            this.setState({ isLoading: false });
            this.toast.show({ severity: 'error', summary: 'Please approve/reject all the fee types', detail: 'Please approve/reject all the fee types', life: 3000 });
            return;
        }

        if (concessionMode === 'REPLACE' && pendingConcessions.length > 0) {
            const approvals = pendingConcessions.map((item) => item?.isConcessionApproved === true);
            const hasApproved = approvals.some(Boolean);
            const hasRejected = approvals.some((decision) => !decision);

            if (hasApproved && hasRejected) {
                this.setState({ isLoading: false });
                this.toast.show({
                    severity: 'error',
                    summary: 'Replace Concession Validation',
                    detail: 'Replace concession requests must be fully approved or fully rejected.',
                    life: 3000
                });
                return;
            }
        }

        let payload
        if (!selectedStudent?.length) {
            payload = [{
                _id: raisedFeeConcessionsData?._id,
                user_id: raisedFeeConcessionsData?.user_id,
                academicYear: raisedFeeConcessionsData?.academicYear,
                isClosed: true,
                enrollmentId: raisedFeeConcessionsData?.username?.slice(3),
                concessionsRaised: raisedFeeConcessionsData?.concessionsRaised,
                concessionRaisingRemarks: raisedFeeConcessionsData?.concessionRaisingRemarks,
                concessionMode,
                remarks: remarks,
                branchId: raisedFeeConcessionsData?.branchId,
                handledBy: this.state.raisedFeeConcessionsData?.handledBy || [],
                levelAndBranchDetails: this.state.dropdownsData?.heirarchy?.adminLevels?.filter((al) => al._id == this.state.raisedFeeConcessionsData?.branchId)
            }]

        } else {
            payload = [...this.state.selectedStudent.map(student => ({
                _id: student?._id,
                user_id: student?.user_id,
                enrollmentId: student?.username?.slice(3),
                isClosed: true,
                academicYear: student?.academicYear,
                concessionsRaised: student?.concessionsRaised,
                concessionRaisingRemarks: student?.concessionRaisingRemarks,
                concessionMode: (student?.concessionMode || 'ADD').toUpperCase(),
                remarks: this.state.bulkApprovalRemarks,
                branchId: student?.branchId,
                handledBy: this.state.raisedFeeConcessionsData?.handledBy || [],
                levelAndBranchDetails: this.state.dropdownsData?.heirarchy?.adminLevels?.filter((al) => al._id == student?.branchId)
            }))
            ]

        }
        let url = `${baseUrlAdmin}/concession-approval/update-concession-approvals`;
        this.service
            .put(url, payload, true)
            .then((res) => {
                if (res?.status && res?.res?.status) {
                    this.setState(
                        {
                            viewConcessionsDetails: false,
                            raisedFeeConcessionsData: {},
                            remarks: '',
                            isLoading: false
                        }
                    );
                    // window.location.reload()
                    this.toast.show({ severity: 'success', summary: 'Concession approved successfully', detail: res.res.message.message, life: 3000 });
                    this.getStudentsInfo();
                } else {
                    this.setState({ isLoading: false });
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });

                }
            })
            .catch((error) => {
                this.setState({ isLoading: false });
            });
    };

    handleSetSearchValue = (value) => {
        this.setState(
            {
                searchValue: value,
                dropdownsData: { ...this.state.dropdownsData, boardId: '', branchId: '', classId: '', sectionId: '' }
            },
            () => {
                if (!this.state.searchValue == '') {
                    this.debouncedApiCall();
                }
            }
        );
    };
    handleSearchLevel = (value) => {
        this.setState({ searchLevel: value, studentId: '', searchValue: '', studentsData: [] }, () => {
            // Clear child input when radio changes
            if (this.studentSearchRef.current && this.studentSearchRef.current.clearInput) {
                this.studentSearchRef.current.clearInput();
            }
        });
    };

    onStudentChange = (e) => {
        this.setState({ studentId: e.value }, () => {
            this.getStudentsInfo();
        });
    };

    // handleSetSearchTypeValue = (value) => {
    //     this.setState({ searchType: value }, () => {
    //         if (this.state.searchType == 'studentName') {
    //             this.setState({ isUserNameSearch: true });
    //         } else {
    //             this.setState({ isUserEnrollSearch: true });
    //         }
    //     });
    // };
    getStudentsInfo = () => {
        let { lazyParams, globalSearch, filterData } = this.state;
        this.setState({ isLoading: true, studentInfo: [] });
        const url = `${baseUrlAdmin}/concession-approval/get-concession-approvals?limit=${lazyParams.rows}&page=${lazyParams.page + 1}&search=${globalSearch}`;

        let academicYear = localStorage.getItem('userAcademicYear');
        let username = this.state.searchType === 'studentName' ? this.state?.searchValue : '';
        let enrollmentNo = this.state.searchType === 'enrollmentNumber' ? this.state?.searchValue : '';

        let payload = {
            branchId: this.state?.dropdownsData?.branchIds,
            boardId: this.state?.dropdownsData?.boardIds,
            gradeId: this.state?.dropdownsData?.classIds,
            sectionId: this.state?.dropdownsData?.sectionId,
            studentId: this.state?.dropdownsData?.studentIds,
            academicYear: academicYear,
            username: this.state.searchLevel == 2 ? username : '',
            enrollmentNo: enrollmentNo,
            assignedHeirarchy: this.state?.dropdownsData?.heirarchy,
        };

        this.service
            .post(url, payload, true)
            .then((res) => {
                if (res && res.status && res.res.status) {
                    if (res.res?.data && res.res?.data?.length) {
                        this.setState({
                            isLoading: false,
                            studentInfo: res.res.data,
                            studentstotalRecords: res.res.totalRecords
                        });
                    } else if (res.res?.data?.length == 0) {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'success', summary: 'No records found.', detail: '', life: 3000 });
                    } else {
                        this.setState({
                            isLoading: false
                        });
                        this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                    }
                } else {
                    this.setState({
                        isLoading: false
                    });
                    this.toast.show({ severity: 'error', summary: 'Some error occured', detail: res.errMessage, life: 3000 });
                }
            })
            .catch((e) => {
                this.setState({
                    isLoading: false
                });
                console.log(e);
            });
    };
    onHandleFeeConcessionApprove = (rowData, status) => {
        this.setState((prevState) => {
            const updatedItems = prevState.raisedFeeConcessionsData?.concessionsRaised?.map((item) => {
                if (item._id === rowData?._id) {
                    return { ...item, isConcessionApproved: status };
                }
                return item;
            });
            let feeInfo = prevState.raisedFeeConcessionsData;
            return { raisedFeeConcessionsData: { ...feeInfo, concessionsRaised: updatedItems } };
        });
    };
    onSelectionChange = (event) => {
        this.setState({
            selectedRows: event.value
        });
    };
    onHandleConcessionApprove = async (selectedStudentInfo, isConfirmed) => {
        const updatedSelectedStudentInfo = selectedStudentInfo?.map(student => ({
            ...student,
            concessionsRaised: student.concessionsRaised.map(concession => ({
                ...concession,
                isConcessionApproved: true,
                isClosed: true
            }))
        }));
        this.setState({
            isApproved: isConfirmed ? true : false,
            isRejected: !isConfirmed ? true : false,
            selectedStudent: updatedSelectedStudentInfo,
        }, () => this.onHandleApprovedConcessions(this.state.selectedStudent));
    };

    handleBulkApprovalClick = () => {
        this.setState({ showBulkApprovalDialog: true });
    };

    handleBulkApprovalClose = () => {
        this.setState({
            showBulkApprovalDialog: false,
            bulkApprovalRemarks: ''
        });
    };

    handleBulkApprovalSubmit = async () => {
        if (this.state?.selectedRows?.length > 0) {
            await this.onHandleConcessionApprove(this.state.selectedRows, true);
            await this.handleBulkApprovalClose();
        }
    };
    onPage = (event) => {
        this.setState((prevState) => {
            return {
                lazyParams: {
                    ...prevState.lazyParams,
                    ...event
                }
            };
        });
    }
    renderHeader() {
        return (
            <div className="flex justify-content-between align-items-center">
                <span className="p-input-icon-left">
                    <i className="pi pi-search" />
                    <InputText value={this.state.globalFilterValue} onChange={this.onGlobalFilterChange} placeholder="Name / Id" />
                </span>
                {/* <h5 className="m-0">Customers</h5> */}
            </div>
        )
    }
    onGlobalFilterChange = (e) => {
        const value = e.target.value;
        let filters = { ...this.state.filters };
        filters['global'].value = value;
        this.setState({ filters, globalFilterValue: value });
    };
    render() {

        const header = this.renderHeader();

        return (
            <div className="ma-main feeConcessionApprovals">
                <div className=" datatable-crud-demo ma-m30 mx-2 mb-5">

                    <div className="flex">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton
                                inputId="ingredient1"
                                onChange={(e) => this.handleSearchLevel(1)}
                                checked={this.state.searchLevel === 1}
                            />
                        </div>

                        <div>
                            <BranchToSectionApprovalHierarchy
                                selectedValue={this.state.searchLevel}
                                setValues={this.setDropdownValues}
                                approvalType={'feeConcession'}
                            />
                        </div>
                    </div>

                    {/* <div className="flex mt-4">
                        <div className="flex flex-column justify-content-center align-items-center mt-3">
                            <RadioButton
                                inputId="ingredient2"
                                onChange={(e) => this.handleSearchLevel(2)}
                                checked={this.state.searchLevel === 2}
                            />
                        </div>

                        <div className="field ml-4">
                            <ClassetStudentSearchFilter
                                ref={this.studentSearchRef}
                                selectedValue={this.state.searchLevel}
                                setValues={this.setDropdownValues}
                            />
                        </div>
                    </div> */}

                </div>
                <DataTable

                    ref={(el) => (this.dt = el)}
                    value={this.state.studentInfo}
                    dataKey="_id"
                    paginator
                    lazy={false} // Changed to false for front-end pagination
                    responsiveLayout="scroll"
                    className="dataTableValuesText"
                    showGridlines
                    selectionMode={'checkbox'}
                    columnResizeMode="expand"
                    resizableColumns
                    onPage={this.onPage}
                    first={this.state.lazyParams.first}
                    last={this.state.studentstotalRecords}
                    rows={this.state.lazyParams.rows}
                    totalRecords={this.state.studentstotalRecords}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    globalFilter={this.state.globalFilter}
                    onSelectionChange={this.onSelectionChange}
                    selection={this.state.selectedRows}

                    // value={this.state.customers} 
                    // paginator 
                    // className="p-datatable-customers" 
                    header={header}
                    // rows={10}
                    // paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown" 
                    // rowsPerPageOptions={[10, 25, 50]}
                    // dataKey="id"
                    rowHover
                    //   selection={this.state.selectedCustomers} 
                    //   onSelectionChange={e => this.setState({ selectedCustomers: e.value })}
                    filters={this.state.filters} filterDisplay="menu" loading={this.state.loading}
                    //  responsiveLayout="scroll"
                    // globalFilterFields={['name', 'country.name', 'representative.name', 'balance', 'status']} emptyMessage="No customers found."
                    // currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                    globalFilterFields={[
                        'firstName',
                        'lastName',
                        'enrollmentId',
                        'boardName',
                        'gradeName',
                        'sectionName',
                        'totalFee',
                        'concessionRaisedAmt'
                    ]}

                >

                    {/* <DataTable
                    ref={(el) => (this.dt = el)}
                    value={this.state.studentInfo}
                    dataKey="_id"
                    paginator
                    lazy={false} // Changed to false for front-end pagination
                    responsiveLayout="scroll"
                    className="dataTableValuesText"
                    showGridlines
                    selectionMode={'checkbox'}
                    columnResizeMode="expand"
                    resizableColumns
                    onPage={this.onPage}
                    first={this.state.lazyParams.first}
                    last={this.state.studentstotalRecords}
                    rows={this.state.lazyParams.rows}
                    totalRecords={this.state.studentstotalRecords}
                    rowsPerPageOptions={[5, 10, 25, 50, 100]}
                    paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                    currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                    globalFilter={this.state.globalFilter}
                    selection={this.state.selectedRows}
                    onSelectionChange={this.onSelectionChange}
                > */}
                    <Column
                        selectionMode="multiple"
                        style={{
                            width: '50px',
                            textAlign: 'center'
                        }}
                        headerStyle={{
                            backgroundColor: '#f8f9fa',
                            padding: '1rem',
                            fontWeight: '600'
                        }}

                    />
                    <Column
                        // field="name"
                        // header="Name"
                        alignHeader={'center'}
                        sortable
                        bodyClassName="text-center"
                        header="Student Name"
                        body={(rowData, { rowIndex }) => {
                            return (
                                <div className="flex justify-content-center">
                                    {rowData?.firstName}
                                    {rowData?.lastName}
                                </div>
                            );
                        }}
                    ></Column>
                    <Column filterField="enrollmentId" field="enrollmentId" sortable bodyClassName="text-center" header="Enrollment No" alignHeader={'center'} body={(rowData) => {
                        return (
                            <div className="flex justify-content-center">
                                {rowData?.username.slice(3)}
                            </div>
                        )
                    }} />
                    <Column sortable bodyClassName="text-center" header="Board" alignHeader={'center'} body={(rowData) => {
                        return (
                            <div className="flex justify-content-center">
                                {rowData?.boardName}
                            </div>
                        )
                    }} />
                    <Column sortable bodyClassName="text-center" header="Grade-Section" alignHeader={'center'} body={(rowData) => {
                        return (
                            <div className="flex justify-content-center">
                                {rowData?.gradeName} - {rowData?.sectionName}
                            </div>
                        )
                    }} />
                    <Column
                        bodyClassName="text-center"
                        header="Fee Types"
                        alignHeader={'center'}
                        style={{ width: '200px', maxWidth: '200px' }} // Add fixed width
                        body={(rowData) => {
                            if (!rowData?.concessionsRaised?.length) {
                                return (
                                    <div className="flex justify-content-center">
                                        No Fee Types
                                    </div>
                                );
                            }
                            const uniqueFeeTypes = [...new Set(
                                rowData.concessionsRaised
                                    .map(concession => concession.feeType)
                                    .filter(Boolean)
                            )];

                            return (
                                <div className="flex justify-content-center text-wrap"
                                    style={{
                                        wordBreak: 'break-word',
                                        whiteSpace: 'normal',
                                        overflowWrap: 'break-word'
                                    }}>
                                    {uniqueFeeTypes.length > 0 ? uniqueFeeTypes.join(', ') : 'No Fee Types'}
                                </div>
                            );
                        }}
                    />
                    <Column filterField="totalFee" field="totalFee" sortable bodyClassName="text-center" header="Total Fee" alignHeader={'center'} />
                    <Column filterField="concessionRaisedAmt" field="concessionRaisedAmt" sortable bodyClassName="text-center" header="Concession" alignHeader={'center'} />
                    <Column
                        alignHeader={'center'}
                        sortable
                        bodyClassName="text-center"
                        header="Details"
                        body={(rowData, { rowIndex }) => {
                            return <Button id={rowData?._id} onClick={() => this.onHandleViewFeeConcessions(rowData)} icon="pi pi-ellipsis-v" className=" p-button-text p-button-secondary ma-ml10" />;
                        }}
                    ></Column>
                </DataTable>

                <div className="flex justify-content-end my-2 mr-2">
                    <Button
                        className="px-4 py-2"
                        style={{
                            backgroundColor: '#268900',
                            border: 'none',
                            borderRadius: '8px',
                            color: 'white',
                            height: '48px',
                            fontSize: '16px',
                        }}
                        disabled={this.state?.selectedRows?.length === 0}
                        onClick={this.handleBulkApprovalClick}
                    >
                        Approve Selected Requests
                    </Button>
                </div>

                <Dialog
                    visible={this.state.showBulkApprovalDialog}
                    className="w-6"
                    draggable={false}
                    onHide={this.handleBulkApprovalClose}
                    header={<div className="mt-2 mb-4">
                        <h5 className="formhead text-center">Confirm Requests</h5>
                    </div>}
                >
                    <div className="mt-3">
                        <label className="">Remarks</label>
                        <div className="mt-2">
                            <ClassetTextArea
                                placeholder="Enter remarks"
                                width="100%"
                                height="150px"
                                value={this.state.bulkApprovalRemarks}
                                onChange={(e) => this.setState({ bulkApprovalRemarks: e.target.value })}
                            />
                        </div>
                    </div>
                    <div className="flex justify-content-center align-items-center mt-4">
                        <Button
                            label="Submit"
                            className="submitButtonn mr-4 button text-lg"
                            onClick={this.handleBulkApprovalSubmit}
                        />
                        <Button
                            className="cancelButtonn"
                            onClick={this.handleBulkApprovalClose}
                        >
                            <p className="cancelButtonnText">Cancel</p>
                        </Button>
                    </div>
                </Dialog>

                <Dialog
                    isopen={this.state.viewConcessionsDetails}
                    visible={this.state.viewConcessionsDetails}
                    className="w-11"
                    draggable={false}
                    onHide={this.onHandleConcessionClose}
                    closable={true}
                    header={() => {
                        return (
                            <div className="mt-2 mb-4">
                                <h3 className="formhead text-center ">Approve Raised Concessions</h3>
                            </div>
                        );
                    }}
                    footer={() => <div className="flex justify-content-center align-items-center mb-4"></div>}
                >
                    <>
                        <div className="grid m-2">
                            <div className="col-4 ">
                                <label className="ma-label-s2 font-serif font-semibold text-900 text-lg">Student Name</label>
                                <div className="mt-2">
                                    <ClassetInputText
                                        id="studentName"
                                        className=""
                                        height="48px"
                                        width="368px"
                                        value={`${this.state?.raisedFeeConcessionsData?.firstName}` + " " + `${this.state?.raisedFeeConcessionsData?.lastName}`}
                                        disabled={true}
                                    />
                                </div>
                            </div>
                            <div className="col-4 ">
                                <label className="ma-label-s2 font-serif font-semibold text-900 text-lg">Enrollment No</label>
                                <div className="mt-2">
                                    <ClassetInputText id="enrollmentNo"
                                        height="48px" width="368px" value={this.state?.raisedFeeConcessionsData?.enrollmentId || this.state?.raisedFeeConcessionsData?.username?.slice(3)} disabled={true} />
                                </div>
                            </div>
                            <div className="col-4">
                                <label className="ma-label-s2 font-serif font-semibold text-900 text-lg">Grade</label>
                                <div className="mt-2">
                                    <ClassetInputText id="grade"
                                        height="48px" width="368px" value={this.state?.raisedFeeConcessionsData?.gradeName} disabled={true} />
                                </div>
                            </div>
                            <div className="col-4">
                                <label className="ma-label-s2 font-serif font-semibold text-900 text-lg">Section</label>
                                <div className="mt-2">
                                    <ClassetInputText id="section"
                                        height="48px" width="368px" value={this.state?.raisedFeeConcessionsData?.sectionName} disabled={true} />
                                </div>
                            </div>
                            <div className="col-4">
                                <label className="ma-label-s2 font-serif font-semibold text-900 text-lg">Board</label>
                                <div className="mt-2">
                                    <ClassetInputText id="board"
                                        height="48px" width="368px" value={this.state?.raisedFeeConcessionsData?.boardName} disabled={true} />
                                </div>
                            </div>
                        </div>

                        <DataTable
                            ref={(el) => (this.dt = el)}
                            value={this.state?.raisedFeeConcessionsData?.concessionsRaised?.filter(e => e?.isClosed == false || e?.isClosed == undefined)}
                            dataKey="id"
                            paginator
                            rows={10}
                            rowsPerPageOptions={[5, 10, 25, 50, 100]}
                            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                            currentPageReportTemplate="Showing {first} to {last} of {totalRecords}"
                            globalFilter={this.state.globalFilter}
                        >
                            <Column filterField="feeType" field="feeType" sortable bodyClassName="text-center" header="Fee Type" alignHeader={'center'} />
                            <Column
                                filterField="feeTermName"
                                sortable
                                bodyClassName="text-center"
                                header="Fee Term"
                                alignHeader={'center'}
                                body={(rowData, index) => {
                                    return <p>{`${rowData?.paymentTerm}`}</p>;
                                }}
                            />
                            <Column filterField="termWiseActualValue" field="termWiseActualValue" sortable bodyClassName="text-center" header="Term wise Actual Fee" alignHeader={'center'} />
                            <Column filterField="concession" field="concession" sortable bodyClassName="text-center" header="Past Concession" alignHeader={'center'} />
                            <Column filterField="amountPaid" field="amountPaid" sortable bodyClassName="text-center" header="Paid Fee" alignHeader={'center'} />
                            <Column bodyClassName="text-center" header="Concession Type" alignHeader={'center'} field="concessionType" />
                            <Column
                                filterField="concessionValue"
                                field="termWisePercentageOrValue"
                                sortable
                                bodyClassName="text-center"
                                header="Concession Value"
                                alignHeader={'center'}
                                body={(rowData, index) => {
                                    return <p>{rowData?.currentConAmt || 0}</p>;
                                }}
                            />
                            <Column
                                filterField="totalDue"
                                field=""
                                sortable
                                bodyClassName="text-center"
                                header="Total Due"
                                alignHeader={'center'}
                                body={(rowData, index) => {
                                    let dueAmount = Number(rowData?.dueAmount) || 0;
                                    let conAmt = Number(rowData?.currentConAmt) || 0;
                                    const concessionMode = (rowData?.concessionMode || this.state?.raisedFeeConcessionsData?.concessionMode || 'ADD').toUpperCase();
                                    const finalDue = concessionMode === 'REPLACE'
                                        ? Number(dueAmount + conAmt).toFixed(2)
                                        : Number(Math.max(dueAmount - conAmt, 0)).toFixed(2);
                                    return <p>{finalDue}</p>;
                                }}
                            />
                            <Column
                                style={{ width: '15rem', height: '6rem' }}
                                alignHeader={'center'}
                                sortable
                                headerClassName="text-color-secondary"
                                bodyClassName="text-center"
                                className=" "
                                header="Approve / Reject"
                                body={(rowData, { rowIndex }) => {
                                    return (
                                        <>
                                            {rowData?.isConcessionApproved == undefined && (
                                                <div className="flex justify-content-evenly">
                                                    <div className="cursor-pointer" onClick={() => this.onHandleFeeConcessionApprove(rowData, true)}>
                                                        <GreenCheck />
                                                    </div>

                                                    <div className="cursor-pointer" onClick={() => this.onHandleFeeConcessionApprove(rowData, false)}>
                                                        <CancelRed />
                                                    </div>
                                                </div>
                                            )}

                                            {rowData?.isConcessionApproved == true && (
                                                <div className="cursor-pointer">
                                                    <Button className="approve-btn" style={{ backgroundColor: '#268900' }}>
                                                        Approved
                                                    </Button>
                                                </div>
                                            )}
                                            {rowData?.isConcessionApproved == false && (
                                                <div className="cursor-pointer">
                                                    <Button className="approve-btn" style={{ backgroundColor: '#BF0031' }}>
                                                        Rejected
                                                    </Button>
                                                </div>
                                            )}
                                        </>
                                    );
                                }}
                            ></Column>
                        </DataTable>
                        <h5 className='mx-2'>Raised Concession Remarks : {this.state?.raisedFeeConcessionsData?.concessionRaisingRemarks}</h5>
                        <div className=" mx-2 my-3">
                            <ClassetTextArea placeholder="Remarks" className="" width={'98%'} height={'150px'} value={this.state.remarks} onChange={(e) => this.setState({ remarks: e.target.value })} />
                        </div>
                        <div className="flex justify-content-center  align-items-center mt-4">
                            <Button label="Confirm" className="submitButtonn mr-4 button text-lg " onClick={this.onHandleApprovedConcessions} />
                            <Button className="cancelButtonn " onClick={() => this.onHandleConcessionClose()}>
                                <p className="cancelButtonnText">Cancel</p>
                            </Button>
                        </div>
                    </>
                </Dialog>

                <Toast ref={(el) => (this.toast = el)} position="bottom-right" />
                {this.state.isLoading && <LoadingComponent />}
            </div>
        );
    }
}

export default withRouter(Authentication(FeeConcessionApprovals));
